import {
    AnalyticsRequest,
    Metric,
    GroupBy,
    Sort,
} from '../../PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultPosition } from '../../PanelTemplatesTheme/constants';
import { Panel } from '../../../../models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from '../../../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';

export const TemplateHyperSpaceBarChart: Panel = {
    id: 'hyper-space-bar-chart',
    name: 'Bar Chart',
    description: '',
    tags: ['Standard', 'Bar Chart', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_bar_chart',
        children: [
            {
                type: 'hyperSpaceBarChart',
                id: 'hyper-space-bar-chart',
                name: 'Bar Chart',
                useGlobalTimePeriod: true,
                useGlobalTranslate: true,
                translationLanguage: null,
                analyticsRequests: [
                    new AnalyticsRequest({
                        limit: 6,
                        groupBys: [
                            new GroupBy({
                                LISTENING: { source: ListeningDimensions.topicName },
                                INBOUND_MESSAGE: { dimensionName: 'ACCOUNT_ID' },
                                PLATFORM: { dimensionName: 'ACCOUNT_ID' },
                                BENCHMARKING: { dimensionName: 'BENCHMARKING_ACCOUNT_ID' },
                                PAID: { dimensionName: 'accountIds' },
                                ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                                RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                                STORY_MESSAGE: { dimensionName: 'RDB_DATA_SOURCE' },
                                UNIVERSAL_PROFILE: { dimensionName: 'SN_TYPE' },
                                VOICE: { dimensionName: 'ACCOUNT_ID' },
                                TWITTER: { dimensionName: 'TRENDING_TOPIC' },
                                SPR_TASK: { dimensionName: 'ASSIGNEE_ID' },
                                COMMUNITY: { dimensionName: 'AUDIENCE_ACTIVITY_TYPE' },
                            }),
                        ],
                        sorts: [
                            new Sort({ order: 'DESC', projections: 0 }),
                            new Sort({ order: 'ASC', groupBys: 0 }),
                        ],
                        timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
                    }) as any,
                ],
                position: DefaultPosition,
                label: {
                    titleText: 'Bar Chart',
                    size: WIDGET_LABEL_SIZE.primary,
                    enabled: false,
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                    },
                    includeMetrics: false,
                    zeroFill: true,
                    baseXYChartOptions: {
                        grid: {
                            enabled: false,
                        },
                        xAxis: {
                            ticks: {
                                formats: {
                                    numberFormat: {
                                        decimals: 0,
                                        useShortened: true,
                                    },
                                    dateFormat: {
                                        autoFormat: true,
                                        formatString: 'dd MMM',
                                    },
                                },
                                numTicks: 5,
                            },
                            enabled: true,
                            label: {
                                enabled: true,
                                size: 50,
                            },
                            line: {
                                enabled: false,
                                stroke: '',
                                strokeWidth: 1,
                            },
                        },
                        yAxis: {
                            ticks: {
                                formats: {
                                    numberFormat: {
                                        decimals: 0,
                                        useShortened: true,
                                    },
                                    dateFormat: {
                                        autoFormat: true,
                                        formatString: 'dd MMM',
                                    },
                                },
                                numTicks: 5,
                            },
                            enabled: true,
                            label: {
                                enabled: true,
                                size: 50,
                            },
                            line: {
                                enabled: false,
                                stroke: '',
                                strokeWidth: 1,
                            },
                        },
                    },
                },
            },
        ],
    },
};
